import { Fragment, useRef } from 'react';
import { useUserProfile } from '../../../../../providers/user-provider';
import ExternalLinks, {
  AccountMobileMenu,
  NotificationDialog,
} from '../../desktop/headerComponents/header-steps';
import { DataAnalyticsLocations, DataAnalyticsTypes } from '../../../../basic/analytics';
import RegionNavLink from './region-navlink';
import { getSession } from '../../../../../utils/sessionStorageUtils';

interface IHeaderToolbarProps {
  navToolbarMap: any;
  regionMessages: any;
}

enum COMPONENTTYPE {
  BUTTON = 'BUTTON',
  EXTERNALLINK = 'EXTERNALLINK',
  DIALOG = 'DIALOG',
  REGION = 'REGION',
  NEWMENU = 'NEWMENU',
}

enum NavToolbarIcons {
  ShowAfterLogin = 'showafterlogin',
  Authenticated = 'authenticated',
  Cart = 'cart',
  Logout = 'Logout',
  Notification = 'Notifications',
  None = 'None',
}

const HeaderToolbar: React.FC<IHeaderToolbarProps> = ({ navToolbarMap, regionMessages }) => {
  const { userProfile } = useUserProfile();
  const navRef = useRef<HTMLDivElement>(null);
  const isLoggedIn = getSession('isLoggedIn');
  const { loginError } = useUserProfile();
  // Show the logged-in header when profile data exists or the session indicates a logged-in user
  // outside the login route and there is no login error.
  const showLoggedInHeaderView =
    userProfile ??
    (!loginError &&
      isLoggedIn &&
      isLoggedIn === 'true' &&
      location.pathname.split('/')[2] !== 'login');

  const determineType = (key: any) => {
    if (key === 'kporg_link') return COMPONENTTYPE.EXTERNALLINK;
    if (key === 'notifications') return COMPONENTTYPE.DIALOG;
    if (key === 'cart') return COMPONENTTYPE.BUTTON;
    if (key === 'region_pickers') return COMPONENTTYPE.REGION;
    if (key === 'site_navigation_new_menu') return COMPONENTTYPE.NEWMENU;
    return null;
  };

  const renderComponent = (type: COMPONENTTYPE, item: any) => {
    switch (type) {
      case COMPONENTTYPE.REGION:
        return (
          <div className="order-4 pl-1 w-[100%]">
            <RegionNavLink regionMessages={regionMessages} navRef={navRef} />
          </div>
        );
      case COMPONENTTYPE.EXTERNALLINK:
        return (
          <div className="mb-4 pl-5 order-3">
            <ExternalLinks
              href={item?.path}
              label={item?.label}
              type={DataAnalyticsTypes.Link}
              locations={DataAnalyticsLocations.Header}
            />
          </div>
        );
      case COMPONENTTYPE.NEWMENU:
        return showLoggedInHeaderView ? (
          <div className="mb-2 order-2 pl-2">
            <AccountMobileMenu menuMap={item} />
          </div>
        ) : (
          <></>
        );
      case COMPONENTTYPE.DIALOG:
        return showLoggedInHeaderView && item?.displayrule === NavToolbarIcons.ShowAfterLogin ? (
          <div className="pl-5 no-underline order-1 mt-4">
            {' '}
            <NotificationDialog data={item} divider={false} notificationErrorMsg={[]} />{' '}
          </div>
        ) : (
          <></>
        );
      default:
        return <></>;
    }
  };

  if (!navToolbarMap || !navToolbarMap?.topToolbar) return null;
  const { topToolbar } = navToolbarMap;

  return (
    <div data-testid="header-toolbar" className="flex flex-col items-start py-3 bg-inky">
      {Object.keys(topToolbar)?.map((key: any, index: number) => {
        const toolBarItem = topToolbar[key];
        const type = determineType(key);
        return <Fragment key={index}>{type && renderComponent(type, toolBarItem)}</Fragment>;
      })}
    </div>
  );
};

export default HeaderToolbar;
